<glitch-hero mainTitle="MY PROJECTS" subtitle="Take a look at some of my past projects."></glitch-hero>